import React from "react";
import { Box, CircularProgress, Grid, Tooltip, Typography } from "@mui/material";
import { BoldTypography } from "../risk/bottombar/TimelineInfoBarStyle";
import { prettyTimeDesktop, prettyTimeMobile } from "../risk/bottombar/timelineUtils";
import { useIsMobile } from "../../features/pageWidth/pageWidthSlice";
import {
    useAlertFetchProgress,
    useIsFetchingAlertData,
    useLastReportedAlertUpdateTime,
    useShouldShowAlerts
} from "../../features/alertDisplay/alertDisplaySlice";
import { useIsLeftBarExpanded, useIsRightBarExpanded } from "../../features/Drawer/drawerSlice";
import { TimelineInnerContainer } from "../risk/bottombar/TimelineStyle";
import { WATCHES_WARNINGS_ADVISORIES, WATCHES_WARNINGS_ADVISORIES_DISCLAIMER } from "../UserVisibleStrings";
import { displayName } from "../../app/forecastSurface";


const AlertInfoBar: React.FC = () =>
{
    const isFetching = useIsFetchingAlertData();
    const lastUpdate = useLastReportedAlertUpdateTime();
    const isMobile = useIsMobile();
    const alertFetchProgress = useAlertFetchProgress();
    const isRightBarExpanded = useIsRightBarExpanded();
    const isLeftBarExpanded = useIsLeftBarExpanded();
    const isShowingAlerts = useShouldShowAlerts();

    return (
        <TimelineInnerContainer
            isMobile = {isMobile}
            isRightBarExpanded = {isRightBarExpanded}
            isLeftBarExpanded = {isLeftBarExpanded}
            isVisible = {isShowingAlerts}
        >
            <Grid
                container
                direction = "column"
                justifyContent = "center"
                alignItems = "center"
                sx = {{ width: "100%", textAlign: "center" }}
                spacing = {1}
            >
                <Grid
                    container
                    direction = "row"
                    justifyContent = "center"
                    alignItems = "center"
                    spacing = {1}
                >
                    <Grid item>
                        <Box
                            sx = {{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                backgroundColor: "lightgrey",
                                padding: "4px 16px",
                                borderRadius: "36px",
                                width: isMobile ? "240px" : "300px",
                            }}
                        >
                            <BoldTypography
                                sx = {{
                                    color: "black",
                                    fontSize: isMobile ? "0.8rem" : "1rem",
                                }}
                            >
                                {displayName( WATCHES_WARNINGS_ADVISORIES )}
                            </BoldTypography>
                            <Typography sx = {{ color: "black", fontSize: "0.8rem" }}>
                                {isMobile
                                    ? prettyTimeMobile( lastUpdate )
                                    : prettyTimeDesktop( lastUpdate )}
                            </Typography>
                        </Box>
                    </Grid>

                    {isFetching && (
                        <Grid item>
                            <Tooltip title = "Loading alert data">
                                <CircularProgress size = {15}/>
                            </Tooltip>
                            {alertFetchProgress !== undefined && <span>{( alertFetchProgress * 100 ).toFixed( 1 )}%</span>}
                        </Grid>
                    )}
                </Grid>

                <Grid item>
                    <Box
                        sx = {{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            backgroundColor: "#fff3cd",
                            padding: "4px 16px",
                            borderRadius: "36px",
                            width: isMobile ? "315px" : "500px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <Typography
                            sx = {{
                                color: "#856404",
                                fontSize: isMobile ? "0.75rem" : "0.9rem",
                                fontWeight: 500,
                            }}
                        >
                            {WATCHES_WARNINGS_ADVISORIES_DISCLAIMER}
                        </Typography>
                    </Box>
                </Grid>

            </Grid>
        </TimelineInnerContainer>
    );
};


export default AlertInfoBar;
